module.exports = __webpack_public_path__ + "media/images/teamfit-logo-27ec45a4787af319284e29cb67ab8b0b.png";